export default "__VITE_ASSET__Ot7YNSO4__"